import L, { LatLngExpression } from 'leaflet';
import { ReactNode } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Marker, Tooltip } from 'react-leaflet';

interface CustomMarkerProps {
    position: LatLngExpression;
    children: ReactNode;
    tooltip?: ReactNode;
    onClick?: (event: L.LeafletMouseEvent) => void; // Add onClick prop
}

export default function CustomMarker({ position, children, onClick, tooltip }: CustomMarkerProps) {
    const customIconHtml = ReactDOMServer.renderToString(children);

    // Create an L.divIcon instance
    const customMarkerIcon = new L.DivIcon({
        className: 'my-custom-marker-icon', // Add a class for potential CSS styling
        html: customIconHtml,
        iconSize: [40, 40], // Set the size of the icon (width, height)
        iconAnchor: [20, 40], // Point of the icon which will correspond to marker's location (center bottom)
        popupAnchor: [0, -40], // Point from which the popup should open relative to the iconAnchor
    });

    // Define event handlers
    const eventHandlers = {
        click: (event: L.LeafletMouseEvent) => {
            if (onClick) {
                onClick(event);
            }
        },
    };

    return (
        <Marker position={position} icon={customMarkerIcon} eventHandlers={eventHandlers}>
            {
                tooltip && <Tooltip direction="top" offset={[0, -40]} permanent={false}
                    className="my-tooltip !p-0 !rounded-2xl !bg-white/0 !border-0"
                >
                    {tooltip}
                </Tooltip>
            }
        </Marker>
    );
}